@if( gloss ) {
    <div 
        class="line" 
        [attr.votes]="gloss.votes" 
        [class.currentVote]="gloss.isUsersVote(this.synchronizerService.currentUser?.user_id || '')" 
        [class.ltr]="layoutDirectionLtr()" 
        [class.rtl]="!layoutDirectionLtr()">
        <div (click)="toggleVote()">
            @if( gloss.annotationType != 'null' ) {
                <span class="gloss" [innerHTML]="gloss.html" [appProjectTextStyle]="synchronizerService.currentProject"></span>
            } @else {
                <span class="gloss null">empty</span>
            }
            <mat-icon>check</mat-icon>
            <span class="votes">{{gloss.votes}}</span>
        </div>
        @if( isPowerUser && gloss.gloss_id != -1 ) {
            <mat-icon (click)="editGloss()" class="edit">edit</mat-icon>
        }
    </div>
}